import { ErrorShortSyntax, SHORTENED_ERROR_MESSAGES } from '@/enums';
import { notification } from 'antd';
import { ArgsProps } from 'antd/es/notification/interface';
import { isEmpty } from 'lodash';
import { getI18n } from 'react-i18next';

export type CustomError = {
  response: {
    data: {
      statusCode: number;
      errorCode?: ErrorShortSyntax;
      message?: string;
      details?: Record<string, any>;
    };
  };
};
interface IErr {
  error: { errorCode: string } | CustomError | Error;
  i18nKey?: string;
  contentObj?: Object;
}

export const errorNotification = (input: IErr) => {
  const i18n = getI18n();
  let { i18nKey, contentObj = {} } = input;
  // to not having to update type to every existing error
  // since this one is a refactored
  const error = input.error as unknown as CustomError;
  const errorDetails = error?.response?.data?.details;
  const statusCode = error?.response?.data?.statusCode;
  const errorCode =
    error?.response?.data?.errorCode || (error as any).errorCode;

  // If i18next have not defined for the error code, we show default REFRESH_AND_RETRY error
  if ((!contentObj || isEmpty(contentObj)) && errorDetails) {
    contentObj = errorDetails;
  }
  const reasonText =
    errorCode && i18n.t(`error.${errorCode}`) !== `error.${errorCode}`
      ? i18n.t(`error.${errorCode}`, {
          ...contentObj,
        })
      : i18n.t(`error.${SHORTENED_ERROR_MESSAGES.REFRESH_AND_RETRY}`);

  const errArgs: ArgsProps = {
    // If user provide 18nKey for the notification title, we show as message, if not, we show reason as title text
    message: i18nKey
      ? i18n.t(i18nKey, {
          ...contentObj,
        })
      : reasonText,
  };
  if (i18nKey && errorCode) {
    errArgs.description = reasonText;
  }

  const isLimitNotification = [401].includes(statusCode);

  if (!isLimitNotification) {
    errArgs.key = `${error?.response?.data?.statusCode}-${i18nKey}`;

    notification.error(errArgs);
  }
};
